import React from 'react';
import TopHeader from './TopHeader';

/**
 * Common page header used on every page:
 * page title on the left, notifications + profile dropdown on the right.
 * Pass `children` instead of `title` to render custom content (e.g. a search bar)
 * on the left side.
 */
const PageHeader = ({ title, className = "", children }) => (
    <div className={`aside-right-top-bar page-header-bar ${className}`.trim()}>
        <div className="top-bar-left">
            <div className="top_bar">
                {title ? <h3>{title}</h3> : children}
            </div>
        </div>
        <div className="top-bar-right">
            <TopHeader />
        </div>
    </div>
);

export default PageHeader;
